/**
 * advisorBus — Cross-Tab-Kommunikation für das SB-Portal (Juni 2026).
 *
 * Deeplinks aus Belegprüfung / Periodenabschluss öffnen Einträge in einem
 * NEUEN Tab. Wird dort eine Änderung gespeichert, sendet dieser Tab ein
 * `advisor-data-changed`-Signal über einen BroadcastChannel. Der ursprüngliche
 * Tab (Belegprüfung / Abschluss-Wizard) hört darauf und aktualisiert sich.
 *
 * Hinweis: Ein BroadcastChannel empfängt die eigenen gesendeten Nachrichten
 * NICHT — der sendende Tab triggert sich also nicht selbst.
 */
let channel = null;

export function getAdvisorBus() {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) channel = new BroadcastChannel('ivoliq-advisor');
  return channel;
}

export function postAdvisorChange(payload = {}) {
  const c = getAdvisorBus();
  if (c) c.postMessage({ kind: 'advisor-data-changed', ...payload, ts: Date.now() });
}

/** Abonniert Datenänderungen für einen Mandanten. Gibt eine Cleanup-Funktion zurück. */
export function onAdvisorChange(clientId, handler) {
  const c = getAdvisorBus();
  if (!c) return () => {};
  const listener = (e) => {
    const d = e.data || {};
    if (d.kind !== 'advisor-data-changed') return;
    if (clientId && d.clientId && d.clientId !== clientId) return;
    handler(d);
  };
  c.addEventListener('message', listener);
  return () => c.removeEventListener('message', listener);
}
